<div class="header__inner w-full block relative z-[2] bg-white drop-shadow">
	<div class="container mx-auto">
		<div class="w-full lg:py-2 py-3 px-5 flex flex-wrap items-center justify-between relative z-10">
			<div class="content__logo flex flex-wrap items-center gap-3 sm:pl-5 pl-4">
				<div class="lg:hidden block">
					<a href="javascript:void(0);" class="btn__sidebar md:text-2xl text-xl block w-[25px] h-[25px]">
						<i class="fa-light fa-bars-sort"></i>
					</a>
				</div>
				<div class="lg:block hidden w-[140px] mx-auto max-w-full block m-auto text-xl font__title font-semibold cursor-pointer" routerLink="/" routerDirection="root">
					<img src="/assets/img/qhantuy/logo.png" alt="QH Organizaciones">
				</div>
			</div>

			<div class="w-auto max-w-full">
				<ul class="list-none flex flex-wrap items-center gap-2">

					<li class="relative dropdown_contnt">
						<button mat-button [matMenuTriggerFor]="userDropdown" class="text-gray-800 text-lg py-2 px-4 inline-flex flex-wrap items-center relative before:w-full before:h-full before:transition-all before:duration-300 before:ease-in-out before:absolute before:top-1/2 before:left-1/2 before:-translate-y-1/2 before:-translate-x-1/2 before:scale-50 before:bg-gray-100 before:rounded-xl before:z-[-1] before:opacity-0 hover:before:opacity-100 hover:before:scale-100">
							<i class="fa-light fa-user mr-[5px] w-[22px]"></i>
							<span class="sm:flex sm:flex-col hidden">
								<ng-container *ngIf="!authService.isLoggedIn(); else elseAuth1">
									<span class="text-sm block leading-[normal] font-semibold">Inicia sesión</span>
									<span class="text-[13px] block leading-[normal]">Dashboard</span>
								</ng-container>
								<ng-template #elseAuth1>
									<ng-container *ngIf="user$ | async as _user">
										<span class="text-sm block leading-[normal] font-semibold">{{ _user.first_name+' '+_user.last_name }}</span>
										<span class="text-[13px] block leading-[normal]">Dashboard</span>
									</ng-container>
								</ng-template>
							</span>
							<small><i class="fa-light fa-angle-down sm:ml-[8px]"></i></small>
						</button>
						<mat-menu #userDropdown="matMenu">
							<ul class="py-5 px-4 whitespace-nowrap">
								<ng-container *ngIf="!authService.isLoggedIn(); else elseAuth">
									<li class="w-full">
										<a href="javascript:void(0)" routerLink="/auth" class="text-gray-800 text-base py-2 px-4 inline-flex items-center relative w-full before:transition-all before:duration-300 before:ease-in-out before:absolute before:left-4 before:w-0 before:bottom-0 before:border-b-2 before:border-b-[color:var(--primary-color)] hover:before:w-[50%]">
											<i class="fa-light fa-arrow-right-to-bracket mr-[5px] text-base w-[20px]"></i>
											<span>Iniciar sesión</span>
										</a>
									</li>
								</ng-container>
								<ng-template #elseAuth>
									<li class="w-full">
										<a href="javascript:void(0)" (click)="logout()" class="text-gray-800 text-base py-2 px-4 inline-flex items-center relative w-full before:transition-all before:duration-300 before:ease-in-out before:absolute before:left-4 before:w-0 before:bottom-0 before:border-b-2 before:border-b-[color:var(--primary-color)] hover:before:w-[50%]">
											<i class="fa-light fa-arrow-right-from-bracket mr-[5px] text-base w-[20px]"></i>
											<span>Cerrar Sesión</span>
										</a>
									</li>
								</ng-template>
							</ul>
						</mat-menu>
					</li>
				</ul>
			</div>
		</div>
	</div>
</div>
